module.exports = __webpack_public_path__ + "public/img/15.6f4ec54e.png";